import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,AlertController, DateTime} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS,URL_SERVICIOS_LOCALESFRONT } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CajaProvider } from '../../providers/caja/caja'
import * as moment from 'moment';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-ventas-diarias-por-costos',
  templateUrl: 'ventas-diarias-por-costos.html',
  providers: [ AuthService ,InAppBrowser]
})
export class VentasDiariasPorCostosPage {
  datosPagina:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  fecha:Date
  fechahasta:Date
  data:any
  constructor(public navCtrl: NavController, public navParams: NavParams,
             public alertControllers:AlertController,
             public storages:Storage,
             public auth: AuthService,
             public servicioCompania:CompaniasProvider,private iab: InAppBrowser,
             public servicio:CajaProvider,
             public utils: UtilsProvider) {
              this.data = moment();
            
              if(!MODO_DESCONECTADO){
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })
                this.storages.set('imprimirArchivo','')
               }else{
               
                 this.navCtrl.setRoot('PrincipalPage');
               }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VentasDiariasPorCostosPage');
  }
  public event = {
    default: "ddd MMM DD YYYY HH:mm:ss"
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  buscarVenta(){
    let fecha = this.fecha 
    let fechahasta = this.fechahasta
    let diferencia = this.validarFechas(fecha,fechahasta)
    if(diferencia<0){
      this.utils.mensajeMuestro('La fecha hasta debe ser mayor o igual a la fecha desde','Advertencia!','Advertencia')
      return false
    }
    // '2018-07-28 00:00:00.000'
    
  this.storages.get('companiasId').then((val) => {

    for(let i =0; i<= diferencia;i++){
      if(fecha!==undefined && fechahasta!==undefined){
        
        // this.fecha.setDate(this.fecha.getDae() + i);

        // 
       let fechaa= new Date(this.fecha)
      //  let hoy = new Date();
      let ii = i == 0 ? 1 : i + 1
      let semanaEnMilisegundos = 1000 * 60 * 60 * 24 * ii;
      let suma = fechaa.getTime() + semanaEnMilisegundos; //getTime devuelve milisegundos de esa fecha
      let fechaaaa = new Date(suma);
      var anno=fechaaaa.getFullYear();
      let mes= fechaaaa.getMonth()+1;
      let  dia= fechaaaa.getDate();
      let mesreal =  mes < 10 ? "0" + mes : mes;
      let diareal = (dia < 10) ? ("0" + dia) : dia;
      var fechaFinal = anno+'-'+mesreal+'-'+diareal;
        this.servicio.buscarinformePorFechas(fechaFinal,val)
        .subscribe((data)=>{

          let res = NUBE_AWS ? JSON.parse(data['_body']).data[0] : JSON.parse(data['_body'])
          let stringRes = JSON.stringify(res)
          let valores = JSON.parse(stringRes)
          
          this.reemprimirRecibo(valores)
        },(error)=>{
          
          console.log(error)
        })
     }else{
      this.utils.mensajeMuestro('Debe seleccionar una fecha','Advertencia!','Advertencia')
     }
    }
    })
  }

  validarFechas(fecha:Date,fechahasta:Date){
    
    let inicial = moment(fecha);
    let final = moment(fechahasta);
    let diferencia = final.diff(inicial, 'days');
    return diferencia
  }
  
  descargarArchivo(){
    this.mostrarMensajes('Actualmente no es permitido descargar esta información','Verifique')
    // this.storages.get('imprimirArchivo').then((val) => {
    //   if(val){
    //     this.iab.create(`${URL_SERVICIOS_LOCALESFRONT}/assets/${val}.xlsx`,'_system')
    //   }else{
    //     this.mostrarMensajes('Debe buscar la venta antes de poder descargarla','Verifique')
    //   }
        
    // })
    
  }

  imprimirRecibo(){
    this.storages.get('ventasDiarias').then((val) => {
      if(val){
        
        let data = JSON.parse(val)
        this.reemprimirRecibo(data)
      }else{
        this.mostrarMensajes('Debe buscar la venta antes de poder imprimirla','Verifique')
      }
    })
    
  }
  mostrarMensajes(mensaje,advertencia) {
    let alert = this.alertControllers.create({
      title: advertencia,
      subTitle: mensaje,
      buttons: ['Ok']
    });
    alert.present()
  }  

  reemprimirRecibo(mensaje) {
    let recibo = ''
  

  
  // setTimeout(() => {

    for (let index:any = 0; index < mensaje.length; index++) {
      recibo += mensaje[index]['reciboCaja'] + '\n'
    } 

    this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {
    
              let alert = this.alertControllers.create({
                  title: '',
                  subTitle: recibo,
                  buttons: ['Cerrar']
              });
              alert.present();

          })    
  // }, 2000);

  }
  
}



// WEBPACK FOOTER //
// ./src/pages/ventas-diarias-por-costos/ventas-diarias-por-costos.ts